const toNumber = str => Number(str);

const sort = (a, b) => {
  if (toNumber(a) && toNumber(b)) return toNumber(a) - toNumber(b);

  return a ? a.localeCompare(b) : null;
};

export default sort;
